import { Language } from '../enum';

export const P2L_EMBEDDED_VIDEO: Record<Language, string> = {
  'pt-BR': 'https://youtu.be/q7PehbCCngQ',
  es: 'https://youtu.be/hfhmAHuTNmE',
  en: 'https://youtu.be/hfhmAHuTNmE',
};
